// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Wishlist_fullWidth__FrZcC","hidden":"Wishlist_hidden__pTJdD"};